import { appEnv } from 'shared/envs'
import { getCookieDomain, isomorphicCookies } from 'shared/storage'

import { Bucket } from '../bucket'
import { clientSideOnly } from '../client-side-only'

export const ACTIVE_PAYMENT_PROFILE_BUCKET_KEY = 'stn::active::payment::profile'
export const SELECTED_PAYMENT_PROFILES_BUCKET_KEY = 'stn::selected::payment::profiles'

const ACTIVE_PAYMENT_PROFILE_COOKIE_BASE = 'stn_active_payment_profile'

const PAYMENT_PROFILE_ACCOUNT_KEY = 'stn::payment::profile::account'

// sdx e prd compartilham o domínio .stone.com.br; o sufixo de ambiente evita que o cookie de um vaze no outro.
export function getActivePaymentProfileCookieKey() {
  return `${ACTIVE_PAYMENT_PROFILE_COOKIE_BASE}_${appEnv.getEnv() || 'local'}`
}

export function clearPaymentProfileSelection() {
  clientSideOnly(() => {
    isomorphicCookies.remove(getActivePaymentProfileCookieKey(), {
      domain: getCookieDomain(window.location.href)
    })
    Bucket.local.remove(ACTIVE_PAYMENT_PROFILE_BUCKET_KEY)
    Bucket.local.remove(SELECTED_PAYMENT_PROFILES_BUCKET_KEY)
  })
}

export function syncPaymentProfileAccount(accountId?: string) {
  if (!accountId) return
  clientSideOnly(() => {
    const owner = Bucket.local.get(PAYMENT_PROFILE_ACCOUNT_KEY)
    if (owner && owner !== accountId) clearPaymentProfileSelection()
    Bucket.local.set(PAYMENT_PROFILE_ACCOUNT_KEY, accountId)
  })
}
